<div class="jumbotron">
  <div class="form-row" style="margin-bottom: 2rem;">
    <div class="col-md-10">
      <h3>Fire Cadet Academy Application Form -
        <span style="font-weight:300;">Preview</span>
      </h3>
    </div>
    <div class="col-md-2" style="margin-top: 0.5rem;">
      <label for="cadetfirstname" style="float:right;color:#4d79ff;text-decoration: underline;text-decoration-color: #4d79ff;cursor: pointer;"
        (click)=backToEditCadetForm()>
        <i class="fa fa-angle-double-left leftarrow" aria-hidden="true"></i>&nbsp;Edit application</label>
    </div>
  </div>
  <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
    <div class="col-md-12" style="font-weight:900;font-size: 18px;">
      <p style="margin-bottom:0.5rem">APPLICANT CONFIRMATION</p>
    </div>
  </div>
  <div class="form-row">
    <h6 style="font-weight:bold;text-align: justify;">Please read and accept the disclaimer below and submit your application.</h6>
  </div>

  <div class="form-row">
    <div class="form-check col-md-12" style="margin-top:20px;margin-left:20px;padding-right: 10px">
      <label class="form-check-label" for="confirmationtoSubmit" style="text-align: justify;">
          <input class="form-check-input" type="checkbox" value="" id="confirmationtoSubmit" name="submitButtonDisable" [formControl]="cadetSubmitForm.controls['selectAcknw']"><p> I understand and acknowledge that by checking the box, the 
          details furnished below are true and correct and to the best of my knowledge and belief. I also do understand if any of the below information is found to be false or untrue or
          misleading or misrepresenting, my application might be
          <strong>disqualified</strong>.</p>
      </label>
    </div>
  </div>
  <!-- <div class="form-row">
      <div class="form-check col-md-12" style="padding-right: 10px">
        <label class="form-check-label" for="confirmationtoSubmit" style="text-align: justify;">
          of my knowledge and belief. I also do understand if any of the below information is found to be false or untrue or
          misleading or misrepresenting, my application might be
          <strong>disqualified</strong>.
        </label>
      </div>
    </div> -->
  <div class="form-row" style="margin-bottom: 0rem;margin-top: 30px">
    <div class="col-md-11">
      <p >Please review the information below and check for any errors. If you wish to make any changes, please use the edit
        application link to make those changes.</p>
    </div>
  </div>
  <form [formGroup]="cadetSubmitForm" novalidate>
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">PERSONAL INFORMATION</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign">US Citizen:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.usCitizenChooseOne}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign">First Name:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.firstNamePers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetmiddlename" class="labelalign">Middle Initial:
        </label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.middleNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetlastname" class="labelalign">Last Name:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.lastNamePers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetmiddlename" class="labelalign">Suffix:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.suffixNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="dateofbirth" class="labelalign">Date of Birth:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.dobMonthPers}}-</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.dobDatePers}}-</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.dobYearPers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="ssnlastfourdigits" class="labelalign">Social Security #:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.ssnPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="streetaddr" class="labelalign">Street Address:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.strtAddrPers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="aptnumber" class="labelalign">Apt/ Floor:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.aptNumPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cityname" class="labelalign">City:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.cityNamePers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="statename" class="labelalign">State:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.stateNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="zipcodepers" class="labelalign">Zip Code:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.zipCodePers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="countrypers" class="labelalign">Country:</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.countryNamePers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cellnumpers" class="labelalign">Cell Number:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.cellNumPers}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="homenumpers" class="labelalign">Home Number:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.homeNumPers}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="emailpers" class="labelalign">Email:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.emailAddrPers}}</label>
      </div>
    </div>
    <!-- ############################################# -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">EDUCATIONAL DETAILS</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="graduatedfrom" class="labelalign">Graduated from/Have a :</label>
      </div>
      <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.eduChooseOne}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="highschoolinfo" class="labelalign">Name of the School:</label>
      </div>
      <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.schoolNameEdu}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="addressinfo" class="labelalign">Address:</label>
      </div>
      <div class="col-md-5 col-sm-5">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.schoolAddrEdu}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cityeduinfo" class="labelalign">City:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.cityNameEdu}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="stateeduinfo" class="labelalign">State:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.stateNameEdu}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="zipcodeeduinfo" class="labelalign">Zip Code:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.zipCodeEdu}}</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="countryeduinfo" class="labelalign">Country:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.countryNameEdu}}</label>
      </div>
    </div>

    <!-- ############################################# -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">EMPLOYMENT DETAILS</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="employedyrs" class="labelalign">Years of Paid Employment:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.yrsPaidEmpSelection}}</label>
      </div>
      <div class="col-md-6 offset-md-1" style="padding-top: 0.5rem;">
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="employmentyears1">{{this.cadetData.YrsEmpSelectOne}}</label>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="internyrs" class="labelalign">Internship:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.intrnShipSelection}}</label>
      </div>
      <div class="col-md-6 offset-md-1" style="padding-top: 0.5rem;">
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="internshipyears1">{{this.cadetData.intrnShipSelectOne}}</label>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3">
        <label for="currentemployedyrs" class="labelalign">Currently Employed:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.currentEmplySelection}}</label>
      </div>
      <div class="col-md-6 offset-md-1" style="padding-top: 0.5rem;" *ngIf="this.currentEmplyYes === 'Yes'">
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="currentlyemployedyears1">{{this.cadetData.currentEmplySelectOne}}</label>
        </div>
      </div>
    </div>
    <div class="form-row" *ngIf="this.currentEmplyYes === 'Yes'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 offset-md-3">
        <label for="typeofwork">Please specify the work type:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" style="font-weight:bold">{{this.cadetData.workTypeEdu}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="terminatedjob">Have you ever been
          <br/>terminated from a job:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.jobTermSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.jobTermSelectionYes === 'Yes'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 offset-md-3">
        <label for="reasonjobterm">Please specify the reason:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" style="font-weight:bold">{{this.cadetData.jobTermReason}}</label>
      </div>
    </div>
    <!-- ############################################# -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">MILITARY SERVICE</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="servedmilitaryservice" class="labelalign">Served in the U.S Military:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryServSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.militaryServSelectionYes === 'Yes'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 offset-md-3">
        <label for="branchmilitary">Please specify the branch:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" style="font-weight:bold">{{this.cadetData.militaryBranchServ}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.militaryServSelectionYes === 'Yes'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="datesmilitaryservice" class="labelalign">Dates Served:</label>
      </div>
      <div class="col-md-1">
        <label for="fromdatemilitary" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryDateServFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryDateServFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryDateServFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="todatemilitary" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryBranchServTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryBranchServTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.militaryBranchServTo.year}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.militaryServSelectionYes === 'Yes'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="typeofdischarge" class="labelalign">Discharge Type:</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3" style="padding-top: 0.5rem;">
        <div class="form-check form-check-inline">
          <label class="form-check-label" for="dischargetype2" class="labelalign valuelabelalign">{{this.cadetData.dischTypeSelectOne}}</label>
        </div>
      </div>
    </div>
    <div class="form-row" *ngIf="this.militaryServSelectionYes === 'Yes' && this.otherSelectedDischarge === 'Other'">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 offset-md-3">
        <label for="typeofdischarge">If other, specify the type:</label>
      </div>
      <div class="col-md-4 col-sm-4">
        <label for="cadetfirstname" style="font-weight:bold">{{this.cadetData.dischTypeOtherSelected}}</label>
      </div>
    </div>

    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">PREFERRED REQUIREMENTS</p>
      </div>
    </div>

    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="fdnyexploringdates" class="labelalign">FDNY Exploring Program:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.fdnyExpPrgmSelectionYes === 'Yes'">
      <div class="col-md-1 offset-md-3">
        <label for="fromfdnyexploring" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="tofdnyexploring" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyExpPrgmDateTo.year}}</label>
      </div>
    </div>


    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="fdnyexploringdates" class="labelalign">FDNY High School:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.fdnyHSSelectionYes === 'Yes'">
      <div class="col-md-1 offset-md-3">
        <label for="fromfdnyexploring" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="tofdnyexploring" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyHSDateTo.year}}</label>
      </div>
    </div>


    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="fdnyexploringdates" class="labelalign">YEMSA (Youth EMS Academy):</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEASelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.fdnyYEASelectionYes === 'Yes'">
      <div class="col-md-1 offset-md-3">
        <label for="fromfdnyexploring" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="tofdnyexploring" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.fdnyYEADateTo.year}}</label>
      </div>
    </div>

    <!-- ############################################# -->
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">COMMUNITY/VOLUNTEER SERVICE</p>
      </div>
    </div>
   
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="emsfiredates" class="labelalign">Volunteer EMS/Firefighter:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.volEmsFireSelectionYes === 'Yes'">
      <div class="col-md-1 offset-md-3">
        <label for="fromemsfire" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="toemsfire" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.volEmsFireDateTo.year}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="auxpolice" class="labelalign">Auxiliary Police:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceSelection}}</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.auxPoliceSelectionYes === 'Yes'">
      <div class="col-md-1 offset-md-3">
        <label for="fromauxppolice" class="labelalign">From:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateFrom.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateFrom.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateFrom.year}}</label>
      </div>
      <div class="col-md-1">
        <label for="toauxppolice" class="labelalign">To:</label>
      </div>
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateTo.month}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateTo.day}} /</label>
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.auxPoliceDateTo.year}}</label>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="commvolunteerinfo" class="labelalign">Community/Volunteer Work:</label>
      </div>
      <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.comntyVolSelection}}</label>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4" *ngIf="this.comntyVolSelectionYes === 'Yes'">
        <label for="commservicereason" class="labelalign">Please describe below briefly:</label>
      </div>
    </div>
    <div class="form-row" *ngIf="this.comntyVolSelectionYes === 'Yes'">
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 offset-xl-4 offset-lg-4 offset-md-4 offset-sm-4 ">
        <label for="cadetfirstname" style="font-weight:bold">{{this.cadetData.comntyVolWorkDesc}}
        </label>
      </div>
    </div>
    <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
      <div class="col-md-12" style="font-weight:900;font-size: 18px;">
        <p style="margin-bottom:0.5rem">SPECIAL ACCOMMODATION</p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
        <label for="cadetfirstname" class="labelalign">Are you requesting a special accommodation?</label>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <label for="cadetfirstname" class="labelalign valuelabelalign">{{this.cadetData.saChooseOne}}</label>
      </div>
    </div>
    <div class="form-row" style="margin-top: 2rem;">
      <div class="offset-md-10 col-md-2">
        <label for="cadetfirstname" style="float:right;color:#4d79ff;text-decoration: underline;text-decoration-color: #4d79ff;cursor: pointer;"
          (click)=backToEditCadetForm()>
          <i class="fa fa-angle-double-left leftarrow" aria-hidden="true"></i>&nbsp;Edit application</label>
      </div>
    </div>

    <div style="height:2rem; background-color: #fff;padding: 0rem;margin:0rem;margin-left: -2rem;
    margin-right: -2rem;">
    </div>

    <div class="jumbotron" style="padding: 0rem;">
      <!-- <div class="form-row" style="margin-top: 30px; margin-bottom: 10px;border-bottom:1px solid #d9d9d9;">
          <div class="col-md-12" style="font-weight:900;font-size: 18px;">
            <p style="margin-bottom:0.5rem">APPLICANT CONFIRMATION</p>
          </div>
        </div>
      <h6 style="font-weight:bold;text-align: justify;">Please read and accept the disclaimer below and submit your application.</h6>

      <div class="form-check col-md-12" style="margin-top: 20px;">
        <input class="form-check-input" type="checkbox" value="" id="confirmationtoSubmit" name="submitButtonDisable" [formControl]="cadetSubmitForm.controls['selectAcknw']">
        <label class="form-check-label" for="confirmationtoSubmit" style="text-align: justify; margin-left:10px;line-height: 1.2rem;">
          I understand and acknowledge that by checking the box, the details furnished above are true and correct and to the best of
          my knowledge and belief. I also do understand if any of the above information is found to be false or untrue or
          misleading or misrepresenting, my application might be
          <strong>disqualified</strong>.
        </label>
      </div> -->

      <div class="form-row">
        <div class="col-md-12">
          <p style="color: #cc2900;margin-top:1rem;font-style: italic;margin-bottom: 0;">To prevent automated spam submissions, please solve the captcha below and submit:</p>
        </div>
      </div>
      <!-- <div class="captchastyling col-lg-3 col-xl-3 col-md-4 col-sm-4 col-xs-4" [ngClass]=" {'has-error':!cadetSubmitForm.controls['captchaGenerated'].valid && cadetSubmitForm.controls['captchaGenerated'].touched}">
        <label>What is the
          <strong>SUM</strong> of
          <span style="font-weight: bold;">{{this.captchaTestNum1}}</span> and
          <span style="font-weight: bold;">{{this.captchaTestNum2}}</span>?
        </label>
        <input style="width:50px;" type="text" class="form-control" [formControl]="cadetSubmitForm.controls['captchaGenerated']"
          value="" id="captchaGeneratedBox" name="GeneratedCaptchaBox">
        <div *ngIf="cadetSubmitForm.controls['captchaGenerated'].hasError('required') && cadetSubmitForm.controls['captchaGenerated'].touched"
          class="alert alert-danger col-lg-12 col-xl-12 col-md-12 col-sm-12 col-xs-12">Enter the correct result of the sum
        </div>
      </div> -->
      <!--Re-capcha added-->
      <div class="row panel justify-content-md-center">
        <div class="col-md-4 mb-5">
          <!--this has the key to deploy on the prod cloud--> 
          <re-captcha  class="form-row"  formControlName="captchaGenerated" (resolved)="resolved($event)" siteKey="6LdoK-oUAAAAAIbK_g8WAH9rs00nEUujjiz2RxZR"></re-captcha>
          <!--this has the key to deploy on the dev cloud-->
          <!-- <re-captcha class="form-row"  formControlName="captchaGenerated" (resolved)="resolved($event)" siteKey="6LfNu3AUAAAAAJXytLcQhHICiCJcFIrhhtU13F0b"></re-captcha> -->
          <!--this has the key to deploy on localhost-->
          <!-- <re-captcha class="form-row"  formControlName="captchaGenerated" (resolved)="resolved($event)" siteKey="6LcMm3AUAAAAAMXnKlvKfETEUN5WUeijaQqBiB_p"></re-captcha> -->
        </div>
      </div>

      <div class="form-row">
        <div class="" style="margin-top:20px;margin-left:auto;margin-right:auto;">
          <button type="submit" class="btn btn-primary" [disabled]="!(cadetSubmitForm.valid)" (click)=submitCadetForm(cadetData)>Submit Application Form</button>
        </div>
      </div>
    </div>
  </form>
</div>




// WEBPACK FOOTER //
// ./src/app/cadetpreviewapplicationform/cadetpreviewapplicationform.component.html